import { rosterItemParser } from './rosters/index.js';
import { eraseParser, storeParser } from './eeproms/index.js';
import { powerParser } from './powers/index.js';
import { locoParser, throttleParser } from './throttles/index.js';
import { decoderAddressParser } from './decoders/index.js';
import { turnoutDCCParser, turnoutParser } from './turnouts/index.js';
export const createParser = (parsers) => {
    return {
        parse: async (command) => {
            const results = parsers.map(async (parser) => {
                return await new Promise((resolve, reject) => {
                    try {
                        const result = parser(command);
                        resolve(result);
                    }
                    catch (e) {
                        reject(e);
                    }
                });
            });
            return await Promise.any(results);
        }
    };
};
export const genericParser = () => {
    const allParsers = [
        eraseParser,
        locoParser,
        powerParser,
        rosterItemParser,
        storeParser,
        throttleParser,
        decoderAddressParser,
        turnoutParser,
        turnoutDCCParser
    ];
    return createParser(allParsers);
};
